import {GetMetaTable} from "../components/TableComponents/utils/table_helpers";
import {PrintCell} from "../components/TableComponents/utils/table_formatters";
import React from "react";
import {HEADER_TEXT_CODES} from "../utils/constants";

export default function DownloadAsCSV(samples, filename="download"){
	if(samples.length === 0){
		return
	}
	
	let csvString = GetMetaTable(samples[0].sample_type).map(header => (
		CSVHeaderText(header.headerText)
	)).join() + '\n'
	
	// const csvKeys = GetMetaTable(samples[0].sample_type).map(header => (
	// 	header.name
	// ))
	
	csvString += samples.map(sample => {
		return GetMetaTable(samples[0].sample_type).map(header => {
			const text = PrintCell(header, sample)
			
			if(text === ''){
				return text
			}
	
			return (text !== "+" && text !== "-") ? header.csvFormat(text) : text
		}).join()
	}).join("\n")
	
	const blob = new Blob([csvString], { type: 'text/csv' })
	
	let link = document.createElement("a")
	
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `${filename}.csv`)
	} else {
		link.setAttribute('href', URL.createObjectURL(blob))
		link.setAttribute('download', `${filename}.csv`)
		link.click()
	}
}

const CSVHeaderText = value => {
	return Object.values(HEADER_TEXT_CODES).includes(value.charAt(0)) ? value.slice(1) : value
}